export enum DashboardSubDomain {
  Trainer = "train",
  Student = "recall",
  Report = "report",
}
